import cammiePic from "@/public/images/artists/cammie.png";
import { Artist } from "@/types/types";

export const cammie = {
  id: "7",
  name: "Cammie",
  image: cammiePic,
  description: `Introducing "Cammie," the EDM singer whose vocals carry a sentimental touch. With a voice that seamlessly intertwines with electronic beats, Cammie brings a unique emotional depth to every track.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fcammie-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Pop"],
      secondary: ["Singer", "Sentimental"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 67,
      },
    },
  },
} as const satisfies Artist;
